import React, { useRef } from 'react'
import { BsSearch } from 'react-icons/bs'
import Pagination from 'components/Pagination'
import Select from 'components/Select'
import SubscriptionCourseCard from '../SubscriptionCourseCard'
import states from 'utils/states-filter.json'
import careers from 'utils/careers.json'
import {
  Container,
  FormWrapper,
  InputWrapper,
  PaginateWrapper,
  SubscritionCoursesContainer,
} from './styles'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { FaFilter } from 'react-icons/fa'
import { useGetSubscriptionCourses } from 'pages/Subscription/hooks/use-get-subscription-courses'
import { useSubscriptionParams } from 'pages/Subscription/hooks/use-subscription-params'
import { ListLoader } from './loader'
import { TSubscriptionCourse } from 'pages/Subscription/types'

interface SubscriptionCoursesListProps {
  favoriteCoursesId: string[]
}

const SubscriptionCoursesList: React.FC<SubscriptionCoursesListProps> = ({ favoriteCoursesId }) => {
  const formRef = useRef<FormHandles>()

  const { subscriptionId } = useSubscriptionParams()
  const { swr, params, pagination } = useGetSubscriptionCourses({ subscriptionId })

  const isEmpty = swr.data?.length === 0 && !swr.isLoading

  const renderCards = () =>
    swr.data?.map((course: TSubscriptionCourse) => (
      <SubscriptionCourseCard
        key={course._id}
        name={course.name}
        icon={course.icon}
        numberOfModules={course.numberOfModules}
        courseId={course.courseId}
        isFavorite={favoriteCoursesId.find((f) => f === course.courseId) ? true : false}
        subscriptionId={subscriptionId}
      />
    ))

  return (
    <>
      <Container>
        <h2 className="title">Todos os cursos</h2>
        <InputWrapper>
          <BsSearch size={30} />
          <input placeholder="Buscar curso" onChange={(e) => params.setName(e.target.value)} />
        </InputWrapper>
        <FormWrapper>
          <Form
            ref={formRef}
            onSubmit={() => {
              return
            }}
            autoComplete="false"
          >
            <div className="filterTitle">
              <FaFilter style={{ margin: '0.5rem 0.5rem' }} />
              <h4>Filtrar por:</h4>
            </div>
            <Select
              disabled={swr.isLoading}
              name="career"
              options={careers}
              placeholder="Carreiras"
              defaultValue={''}
              onChange={(e) => params.setCareer(e.target.value)}
            />
            <Select
              disabled={swr.isLoading}
              name="state"
              options={states}
              placeholder="Estado"
              defaultValue={''}
              onChange={(e) => params.setState(e.target.value)}
            />
          </Form>
        </FormWrapper>

        <SubscritionCoursesContainer>
          {swr.isLoading ? <ListLoader /> : renderCards()}

          {isEmpty && <p className="empty-text">Nenhum curso encontrado</p>}
        </SubscritionCoursesContainer>
      </Container>
      <PaginateWrapper>
        <Pagination
          page={pagination.active}
          toFirstPage={pagination.first}
          toLastPage={pagination.last}
          toNextPage={pagination.next}
          toPage={pagination.setPage}
          toPreviousPage={pagination.previous}
          total_pages={pagination.total}
        />
      </PaginateWrapper>
    </>
  )
}

export default SubscriptionCoursesList
